<template>
    <div class="mx-auto container py-4 px-4 md:px-2 lg:px-0">
        <slot/>
    </div>
</template>

